module.exports = __webpack_public_path__ + "static/media/IMG_4705.dc56df60.jpg";